import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const badgeVariants = cva(
  "inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-semibold transition-colors focus:outline-none focus:ring-2 focus:ring-accent focus:ring-offset-2 dark:focus:ring-accent",
  {
    variants: {
      variant: {
        default:
          "border-transparent bg-accent text-white hover:bg-accent-hover dark:bg-accent dark:text-white dark:hover:bg-accent-hover",
        secondary:
          "border-transparent bg-background-secondary text-text-primary hover:bg-background-hover dark:bg-background-dark-secondary dark:text-text-dark-primary dark:hover:bg-background-dark-hover backdrop-blur-xl backdrop-saturate-150",
        destructive:
          "border-transparent bg-error text-white hover:bg-error/90 dark:bg-error dark:text-white dark:hover:bg-error/90",
        outline:
          "border-border bg-background-secondary text-text-primary hover:bg-background-hover dark:border-border-dark dark:bg-background-dark-secondary dark:text-text-dark-primary dark:hover:bg-background-dark-hover backdrop-blur-xl backdrop-saturate-150",
        success:
          "border-transparent bg-success text-white hover:bg-success/90 dark:bg-success dark:text-white dark:hover:bg-success/90",
      },
    },
    defaultVariants: {
      variant: "default",
    },
  }
)

export interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  )
}

export { Badge, badgeVariants }
